export default "__VITE_ASSET__Dyv10PLb__"